module.exports = __webpack_public_path__ + "img/verified.48402fbc.svg";